// Smart API URL detection utility
// Uses relative paths for deployed environments (ingress handles routing)
// Uses env var for localhost development

export const getApiUrl = (includeApiPrefix = true) => {
  // If accessed via deployed URL (preview or production), use relative paths
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // Check for deployed environments (preview or custom domains)
    if (hostname.includes('preview.emergentagent.com') || 
        hostname.includes('ispravawealth.com') ||
        hostname.includes('.emergent.app') ||
        !hostname.includes('localhost')) {
      return includeApiPrefix ? '/api' : '';
    }
  }
  // For localhost development, use the backend URL from env
  const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
  return includeApiPrefix ? `${baseUrl}/api` : baseUrl;
};

// For components that need /api prefix
export const API_URL = getApiUrl(true);

// For components that add /api themselves
export const BASE_URL = getApiUrl(false);

export default API_URL;
